<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="700">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Detalles de la factura</v-toolbar>
        <v-card-text>
          <v-container class="mt-1" v-if="!loading">
            <div v-for="(f, ind) in Object.keys(item)" :key="ind" class="mb-2">
              <v-row no-gutters v-if="f != 'factura' && f != 'datos'">
                <v-col sm="4">
                  <b>{{ f }}:</b>
                </v-col>
                <v-col> {{ item[f] }} </v-col>
              </v-row>
              <v-divider v-if="f != 'factura' && f != 'datos'" class="mb-0 mt-1"></v-divider>
            </div>
          </v-container>

          <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        msg: '',
        item: {},
      };
    },
    components: {},
    methods: {
      openmodal(item) {
        this.msg = '';
        this.dialog = true;
        this.item = item;
        window.console.log(item, this.html);
      },
    },
  };
</script>
